import { Link } from "react-router-dom";
import { PlusIcon } from "./icons";

const PlanNewCard = () => (
  <Link
    to="/plan"
    className="bg-white rounded-2xl border-2 border-dashed border-gray-300 hover:border-teal-400 hover:bg-teal-50/30 transition-all flex flex-col items-center justify-center p-8 min-h-[280px] sm:min-h-[320px] cursor-pointer"
  >
    <div className="w-16 h-16 rounded-full border-2 border-gray-300 flex items-center justify-center text-gray-400 mb-4">
      <PlusIcon />
    </div>
    <h3 className="text-gray-800 font-semibold text-lg mb-1">Plan a New Adventure</h3>
    <p className="text-gray-500 text-sm">Start a new AI-generated itinerary</p>
  </Link>
);

export default PlanNewCard;
